
<div>
    <h4>Légende :</h4>
    <ul>
        <li>Un nom en bleu indique des droits standard.</li>
        <li>Un nom en gris indique des droits de délégation.</li>
        <li>Un nom en noir signifie que l'utilisateur n'a plus les droits.</li>
        <li>Une ligne avec du texte en rouge signifie que cette étape est un retour dans le cycle de validation.</li>
        <li>Un fond orange indique l'étape en cours.</li>
        <li>Un fond rouge indique une annulation du BC.</li>
    </ul>
</div>
<div class="mat-table">
    
    <div class="table_principal">
        <table mat-table [dataSource]="matDataSourceBC"
            matSortDirection="desc" matSortDisableClear>
            <caption>Liste des Cycles de validations</caption>
            <ng-container matColumnDef="Etape initiale">
                <th mat-header-cell *matHeaderCellDef> Etape initiale</th>
                <td mat-cell *matCellDef="let element" class="padding-0" [ngClass]="{'background-next': element.bnext === true}">
                    <div [ngClass]="{'background-annulation': element.etape === 'Annulation', 'text-refus': element.bRetour === true}">
                        {{element.etape}}
                    </div>
                </td>
            </ng-container>
            <ng-container matColumnDef="Etape finale">
                <th mat-header-cell *matHeaderCellDef> Etape finale</th>
                <td mat-cell *matCellDef="let element" class="padding-0" [ngClass]="{'background-next': element.bnext === true}">
                    <div [ngClass]="{'background-annulation': element.etape === 'Annulation', 'text-refus': element.bRetour === true}">
                        {{element.etapeFinale}}
                    </div>
                </td>
            </ng-container>
            <ng-container matColumnDef="Qui">
                <th mat-header-cell *matHeaderCellDef> Qui </th>
                <td mat-cell *matCellDef="let element" class="padding-0" [ngClass]="{'background-next': element.bnext === true}">
                    <div [ngClass]="{'background-annulation': element.etape === 'Annulation', 'text-refus': element.bRetour === true}">
                        <div *ngFor="let user of element.usersStandard" [ngClass]="{'text-standard':element.bRetour === false}">
                            {{user.nom + ' ' + user.prenom}}
                        </div>
                        <div *ngFor="let user of element.usersDeleg" [ngClass]="{'text-deleg':element.bRetour === false}">
                            {{user.nom + ' ' + user.prenom}}
                        </div>
                        <div *ngIf="element.user">
                            {{element.user.nom + ' ' + element.user.prenom}}
                        </div>
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="Quand">
                <th mat-header-cell *matHeaderCellDef> Quand </th>
                <td mat-cell *matCellDef="let element" class="padding-0" [ngClass]="{'background-next': element.bnext === true}"> 
                    <div *ngIf="element.date !== '0001-01-01T00:00:00Z'" [ngClass]="{'background-annulation': element.etape === 'Annulation', 'text-refus': element.bRetour === true}">
                        {{element.date| date:'dd/MM/yyyy'}}
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="Commentaire">
                <th mat-header-cell *matHeaderCellDef> Commentaire </th>
                <td mat-cell *matCellDef="let element" class="padding-0" [ngClass]="{'background-next': element.bnext === true}">
                    <div [ngClass]="{'background-annulation': element.etape === 'Annulation', 'text-refus': element.bRetour === true}">
                        {{element.commentaire}}
                    </div>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumnsBC; sticky: true"></tr>
            <div>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsBC;"
                    [ngClass]="{hovered: row.hovered}">
                </tr>
            </div>
        </table>
    </div>
</div>
